import { makeStyles } from '@mui/styles';

export const useDeliveryContainerCapacityChartStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  wrapper: {
    width: '100%',
    position: 'relative'
  },
  // Band key: swatch on top, label underneath. Chart.js's own legend can only put the
  // label beside the box, so it's disabled and this is rendered as HTML instead.
  legend: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '4px 20px',
    padding: '4px 0 8px'
  },
  legendItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px'
  },
  legendSwatch: {
    display: 'block',
    width: '48px',
    height: '12px',
    borderRadius: '2px'
  },
  legendLabel: {
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 500,
    color: '#595D6E',
    whiteSpace: 'nowrap'
  },
  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-50px',
    marginLeft: '-50px',
    zIndex: 2
  },
  labelOverlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    pointerEvents: 'none',
    fontFamily: 'Poppins'
  },
  rowLabel: {
    position: 'absolute',
    left: 0,
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EBEDF2',
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: 'Poppins',
    overflow: 'hidden',
    // The overlay is click-through so it doesn't swallow the chart's own hover;
    // the labels themselves need to receive it for their tooltip to fire.
    pointerEvents: 'auto'
  },
  // The ellipsis has to live on the text's own box, not the flex container —
  // `text-overflow` doesn't apply to the anonymous flex item the text would
  // otherwise sit in, so an over-long name was clipped at whichever edge
  // `justify-content` pushed it against (the start, here) with no ellipsis.
  // `min-width: 0` lets this shrink below its content width inside the flex row.
  rowLabelText: {
    minWidth: 0,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  // Matches the 12px the two charts' other tooltips use.
  nameTooltip: {
    fontSize: '12px'
  }
}));
